"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceAndQuantityForRequest = exports["default"] = void 0;
var _recalculateOrderHelper = require("../../helpers/recalculateOrderHelper");
var _orderHelper = require("../../helpers/orderHelper");
var _reduxForm = require("redux-form");
var _buySellSelectors = require("../../redux/selectors/buySellSelectors");
var _BuySellLayoutTypes = require("../../components/Retail/RetailBuySell/BuySell/BuySellLayoutTypes");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Middleware for calculating order fee for 'RetailOrderOverviewComponent.js'
 */
var orderFeeMiddleware = function orderFeeMiddleware(store) {
  return function (next) {
    return function (action) {
      var _store$getState = store.getState(),
        form = _store$getState.form,
        level2 = _store$getState.apexCore.level2;
      if (isFeeShouldBeRecalculated(action)) {
        var buySellFormIsInitialized = !!form.buySell;
        var entryForm = {};
        if (buySellFormIsInitialized) {
          entryForm = form.buySell;
          var selectedValue = getPriceAndQuantityForRequest(entryForm, store.getState(), action);

          // This calculation is duplicated in RetailOrderOverviewContainer
          var _config$OrderCalcBuff = _config["default"].OrderCalcBuffer,
            _config$OrderCalcBuff2 = _config$OrderCalcBuff === void 0 ? {} : _config$OrderCalcBuff,
            quantityBuffer = _config$OrderCalcBuff2.quantityBuffer;
          var side = entryForm.values.side;
          var orders = (0, _orderHelper.getOrdersBySide)(side, level2);
          var limitPrice = (0, _orderHelper.getQuantityForPrice)(0, quantityBuffer, orders, false, side).LimitPrice;
          var updatedForm = _objectSpread(_objectSpread({}, entryForm.values), {}, _defineProperty({
            limitPrice: limitPrice
          }, action.meta.field, action.payload));
          updatedForm.quantity = selectedValue.quantity;
          (0, _recalculateOrderHelper.recalculateOrderFormValues)(store, {
            form: updatedForm,
            formName: 'buySell',
            orders: orders
          });
        }
      }
      return next(action);
    };
  };
};
var getPriceAndQuantityForRequest = exports.getPriceAndQuantityForRequest = function getPriceAndQuantityForRequest(form, state) {
  var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    meta: {}
  };
  var isPricePerUnitForm = form.values.layoutType === _BuySellLayoutTypes.BUY_SELL_LAYOUTS.PRICE_PER_UNIT;
  var dealValues = isPricePerUnitForm ? (0, _buySellSelectors.getQuantityDataForPresetAndCustomValuesSelector)(state, form.values.side) : (0, _buySellSelectors.getPriceDataForPresetAndCustomValuesSelector)(state, form.values.side);
  var selectedValue = {
    price: '0',
    quantity: '0'
  };
  if (action.meta.field === 'instrument') {
    selectedValue = getValuesFromCustomChange(form, action);
  }

  // switch to `deal values` radio position
  else if (action.meta.field === 'amountRadio' && action.payload !== 'custom') {
    var fieldToSearch = isPricePerUnitForm ? 'quantity' : 'price';
    selectedValue = (0, _orderHelper.getValuesFromDealValues)(dealValues, action.payload, fieldToSearch);
  }

  // switch to `custom` radio position
  else if (action.meta.field === 'amountRadio' && action.payload === 'custom') {
    selectedValue = getValuesFromCustomChange(form, action);
  }

  // sync `price` and `quantity` if `price` or `quantity` is changed
  else if (action.meta.field === 'price' || action.meta.field === 'quantity') {
    selectedValue = getValuesFromCustomChange(form, action);
  }
  return selectedValue;
};
var getValuesFromCustomChange = function getValuesFromCustomChange(_ref, action) {
  var values = _ref.values;
  var field = action.meta.field;
  return {
    price: field === 'price' ? action.payload : values.price,
    quantity: field === 'quantity' ? action.payload : values.quantity
  };
};
var isFeeShouldBeRecalculated = function isFeeShouldBeRecalculated(action) {
  return action.type === _reduxForm.actionTypes.CHANGE && action.meta.field !== 'fee' && action.meta.field !== 'responseMessage' && action.meta.form === 'buySell';
};
var _default = exports["default"] = orderFeeMiddleware;